import type { GetCampaignResponse } from '@ab-inbev-eu/campaign/src/models/campaign';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import type { CampaignActionWithData } from '@ab-inbev-eu/action/src/utils/types';

interface IState {
  campaign?: GetCampaignResponse;
  campaignActions?: CampaignActionWithData[];
  lastSmsSentAt?: number;
  campaignScansCount: number;
  cardScanAnimationComplete: boolean;
  triviaCompleted?: boolean;
}

export const useApplicationStore = create<IState>()(
  devtools(
    persist(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (_set) => ({
        campaign: undefined,
        lastSmsSentAt: undefined,
        campaignActions: undefined,
        campaignScansCount: 0,
        cardScanAnimationComplete: false,
        triviaCompleted: false,
      }),
      {
        name: 'dtc-application-storage',
        storage: createJSONStorage(() => localStorage),
        partialize(state) {
          const { lastSmsSentAt, cardScanAnimationComplete, triviaCompleted } = state;
          return { lastSmsSentAt, cardScanAnimationComplete, triviaCompleted };
        },
      },
    ),
  ),
);
